import { render, staticRenderFns } from "./BindsSnackbar.vue?vue&type=template&id=18d587f1&"
import script from "./BindsSnackbar.vue?vue&type=script&lang=js&"
export * from "./BindsSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./BindsSnackbar.vue?vue&type=style&index=0&id=18d587f1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports